import { createContext, useContext } from "react";

/**
 * Which way a message travelled, as a property of the message itself rather than of who is viewing
 * it -- two people looking at the same thread see the same inbound/outbound split. `outbound` is
 * right-aligned and primary-colored, `inbound` left-aligned and muted.
 */
export type SimpleChatMessageDirection = "inbound" | "outbound";

// Defaults to `inbound` rather than throwing: the parts are namespaced-only, so a stray usage
// outside the root should degrade to the unstyled/left-aligned case, not crash a conversation view.
const SimpleChatMessageDirectionContext = createContext<SimpleChatMessageDirection>("inbound");

export const SimpleChatMessageDirectionProvider = SimpleChatMessageDirectionContext.Provider;

export const useSimpleChatMessageDirection = () => useContext(SimpleChatMessageDirectionContext);
